import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom'
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBInput,
  MDBContainer,
  MDBRow,
  MDBValidation,
  MDBValidationItem,
  MDBCardTitle,
  MDBCardText,
  MDBCheckbox


}
from 'mdb-react-ui-kit';
import '../../../css/index.css';



function CriarADM() {
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState([]);
  const util = require('../../../utils/index');
  const userLogin = util.getUser();
  const api = require('../../../apis/adm')
  const {id} = useParams();

  const [formValue, setFormValue] = useState({
    idAdministrador: '',
    nomeAdministrador: '',
    senha: '',
  });

  const [checked, setChecked] = useState(false);

  const handleSubmit = async (values) => {
    console.log(formValue);
    values.preventDefault();
    util.isSubmitting()
    const result = await api.atualizarADMApi(formValue);
    result ? toast.success("Atualizado com sucesso!") && navigate("/area-adm") : null;
    util.isSubmitting()
    
  }

  const handleDelet = async () => {
    const object = {
        idAdministrador: id
    }
    util.isSubmitting()
    const result = await api.excluirADMApi(object);
    result ? toast.success("Excluido com sucesso!") && navigate("/area-adm") : null;
    util.isSubmitting()
    
  }

  useEffect(() => {
    const getADM = async () => {
      try {
        const object = {
          id: id,
        };
        const response = await api.pegarADMApi(object);
        const data = await response;

        setUsuario(data[0]);
        setFormValue({
          idAdministrador: id,  
          nomeAdministrador: data[0].nomeusuario,
          senha: data[0].senha,
        });
      } catch (error) {
        console.error('Erro ao obter dados:', error);
      }
    };

    getADM();
  }, [id]);

  const onChange = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  const onBlur = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  return (
    <MDBContainer fluid className=' background-radial-gradient' style={{
      minHeight:'500px',display:"flex", justifyContent:"center", alignItems:"center"
      
      }}>
      <MDBRow center className='w-100 d-flex my-5 flex-column align-items-center'>

          <MDBCard className='bg-dark text-white w-50' style={{borderRadius: '1rem', minWidth: '300px'}}>
              <MDBCardBody className='d-flex flex-column align-items-center'>

              <MDBCardTitle className='text-white my-4'>Bem vindo, {userLogin.nomeusuario}</MDBCardTitle>
                  <MDBValidation className='w-100' onSubmit={!checked ? handleSubmit : handleDelet}>
                    <MDBValidationItem feedback='Por favor digite seu nome!' invalid>
                      <MDBInput 
                        wrapperClass='mb-3 w-100' 
                        labelClass='text-white' 
                        label='Nome' 
                        name='nomeAdministrador'
                        id='formContronomeAdministrador' 
                        type='text' 
                        size="lg"
                        value={formValue.nomeAdministrador || ''}
                        onChange={onChange}
                        onBlur={onBlur} 
                        required
                        style={{color:"white"}}/>
                    </MDBValidationItem >
                    <MDBValidationItem feedback='Por favor digite um login válido' invalid>
                      <MDBInput 
                        className='bg-dark'
                        wrapperClass='mb-3 w-100' 
                        labelClass='text-white' 
                        label='Login' id='formControLogin' 
                        type='text' 
                        size="lg" 
                        style={{color:"white", opacity: 0.4}}
                        name='login'
                        value={usuario.login || ''}
                        onChange={onChange}
                        onBlur={onBlur}
                        required
                        minLength={3}
                        disabled={true}
                        />
                    </MDBValidationItem>
                    <MDBValidationItem feedback='Por favor digite uma senha válida!' invalid>
                      <MDBInput 
                        wrapperClass='mb-3 w-100' 
                        labelClass='text-white' 
                        label='Senha' id='formControPassword' 
                        type='password' 
                        size="lg" 
                        style={{color:"white"}}
                        name='senha'
                        value={formValue.senha || ''}
                        onChange={onChange}
                        onBlur={onBlur} 
                        required
                        minLength={3}
                        
                        />
                    </MDBValidationItem>
                    <div className='my-2'>
                        <MDBCheckbox

                            id='controlledCheckbox'
                            label='Habilitar botão "Exluir"'
                            checked={checked}
                            onChange={() => setChecked(!checked)}
                        />
                    </div>
                    <div className='d-flex justify-content-between align-items-center flex-column'>
                        <MDBBtn 
                            outline 
                            className='my-3 btn-home w-100' 
                            color='white' 
                            size='lg'
                            type='submit'   
                            id='submitForm'  
                            disabled={!checked}                 
                            >
                            
                            excluir
                        </MDBBtn>
                        <MDBBtn 
                            outline 
                            className='px-5 w-100 btn-home' 
                            color='white' 
                            size='lg'
                            type='submit'   
                            id='submitForm'  
                            disabled={false}                 
                            >
                            
                            Editar
                        </MDBBtn>
                      </div>
                      <MDBBtn 
                        outline 
                        className='px-5 w-100 mt-4 btn-home' 
                        color='white' 
                        size='sm'
                        type='submit'   
                        onClick={() => {
                          navigate("/listar-adm")
                        }}
                        >
                        
                        Voltar
                      </MDBBtn>
                  </MDBValidation>
              </MDBCardBody>
          </MDBCard>
      </MDBRow>

    </MDBContainer>
  );
}

export default CriarADM;